import toggleCommonAnimation from "./animate.js";

const animationSelector = '[data-animation]:not([data-animation="none"]):not(#pageHeader [data-animation]):not(#panelMenu [data-animation]):not(#pageFooter [data-animation])';
let observer = null;

function destroyObservers() {
    if (observer) {
        observer.disconnect();
        observer = null;
    }
}

function initObservers(root = document) {
    if (!("IntersectionObserver" in window)) return;
    destroyObservers();

    const elements = root.querySelectorAll(animationSelector);

    observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry, index) => {
            if (!entry.isIntersecting) return;

            const el = entry.target;
            if (el.classList.contains("is-animated")) return;

            // Imposta subito lo stato iniziale GSAP, poi aggiorna le classi:
            // evita un frame in cui il CSS smette di nascondere prima del tween.
            el.classList.add("in-view");
            toggleCommonAnimation(el, index * 0.06);
            el.classList.remove("is-hidden");
            el.classList.add("is-animated");

            obs.unobserve(el);
        });
    }, {
        threshold: 0.01,
        rootMargin: "0px 0px -5% 0px"
    });

    elements.forEach(el => {
        el.classList.add("is-hidden");
        observer.observe(el);
    });
}

export { initObservers, destroyObservers };
